import type { Theme } from '@mui/material';
import { Box, Card } from '@mui/material';
import type { SxProps } from '@mui/system';
import { DateTime } from 'luxon';
import type { FC } from 'react';

interface Props {
  date?: DateTime;
}

const sx: Record<string, SxProps<Theme>> = {
  card: {
    height: '2.8rem',
    minWidth: '4rem',
  },
  date: {
    backgroundColor: (theme) => theme.palette.secondary.main,
    color: (theme) => theme.palette.secondary.contrastText,
    height: '1.4rem',
    minWidth: '4rem',
    textAlign: 'center',
  },
  day: {
    backgroundColor: (theme) => theme.palette.primary.main,
    color: (theme) => theme.palette.primary.contrastText,
    fontWeight: 800,
    height: '1.4rem',
    minWidth: '4rem',
    textAlign: 'center',
  },
  year: {
    backgroundColor: (theme) => theme.palette.primary.main,
    color: (theme) => theme.palette.primary.contrastText,
    fontWeight: 800,
    height: '1.4rem',
    minWidth: '4rem',
    textAlign: 'center',
  },
};

export const DateCard: FC<Props> = ({ date }) => {
  if (!date) {
    return <Card sx={sx.card} />;
  }

  if (date.year !== DateTime.now().year) {
    return (
      <Card sx={sx.card}>
        <Box sx={sx.date}>
          {date.toLocaleString({ day: '2-digit', month: 'short' })}
        </Box>
        <Box sx={sx.year}>{date.toLocaleString({ year: 'numeric' })}</Box>
      </Card>
    );
  }

  return (
    <Card sx={sx.card}>
      <Box sx={sx.day}>{date.toLocaleString({ weekday: 'short' })}</Box>
      <Box sx={sx.date}>
        {date.toLocaleString({ day: '2-digit', month: 'short' })}
      </Box>
    </Card>
  );
};
